import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=0a49284e&scoped=true&"
import script from "./HelloWorld.vue?vue&type=script&lang=js&"
export * from "./HelloWorld.vue?vue&type=script&lang=js&"
import style0 from "./HelloWorld.vue?vue&type=style&index=0&lang=css&"
import style1 from "./HelloWorld.vue?vue&type=style&index=1&id=0a49284e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a49284e",
  null
  
)

export default component.exports